export default __webpack_public_path__ + "static/media/ic-img.5ee955b5.svg";